import Draft from "draft-js";
import { inlineKeyBindings } from "@sonder/editor/source/core/inlineKeyBindings";

export const commandReducer = (
  state: Draft.EditorState,
  command: string,
  isSearchTermActive: boolean,
) => {
  switch (command) {
    case "bold":
    case "code":
    case "italic":
    case "underline":
    case "strikethrough": {
      const inlineOption = inlineKeyBindings.find(
        ({ editorCommand }) => editorCommand === command,
      );
      // Ignore inline options that we don't yet support
      if (!inlineOption) return state;
      return Draft.RichUtils.toggleInlineStyle(state, inlineOption.style);
    }

    case "split-block": {
      const nextContent = Draft.Modifier.splitBlock(
        state.getCurrentContent(),
        state.getSelection(),
      );
      return Draft.EditorState.push(state, nextContent, "split-block");
    }

    case "backspace": {
      return Draft.RichUtils.onBackspace(state);
    }
    case "backspace-word":
    case "backspace-to-start-of-line": {
      // Disable these commands to avoid issues with search term entities
      // !TODO: Handle these properly, while preserving search term entities
      if (isSearchTermActive) return state;
      return Draft.RichUtils.onBackspace(state);
    }

    case "delete": {
      return Draft.RichUtils.onDelete(state);
    }
    case "delete-word":
    case "delete-to-end-of-block": {
      // Disable these commands to avoid issues with search term entities
      // !TODO: Handle these properly, while preserving search term entities
      if (isSearchTermActive) return state;
      return Draft.RichUtils.onDelete(state);
    }

    case "undo":
    case "redo":
    case "secondary-cut":
    case "secondary-paste": {
      // Disable these commands to avoid issues with search term entities
      // !TODO: Handle these properly, while preserving search term entities
      if (isSearchTermActive) return state;

      // Null delegates command handling to the browser
      return null;
    }

    case "transpose-characters":
    case "move-selection-to-start-of-block":
    case "move-selection-to-end-of-block":
    default:
      // Null delegates command handling to the browser
      return null;
  }
};
